<div class="tabs-container">
  <app-leave-balance />
  <app-tabs>
    @for (tab of permittedTabs(); track tab) {
    @switch (tab) {
    @case ('my-Leaves') {
    <app-my-leaves> </app-my-leaves>
    }

    @case ('overview') {
    <app-overview></app-overview>
    }

    @case ('pending-Leaves') {
    <app-pending-leaves></app-pending-leaves>
    }

    @case ('grant-leaves') {
    <app-grant-leaves></app-grant-leaves>
    }

    @case ('categories') {
    <app-users-categories></app-users-categories>
    }
    }
    }
  </app-tabs>
</div>